import { render, staticRenderFns } from "./ChangePasswordEditor.vue?vue&type=template&id=4eab5608&scoped=true"
import script from "./ChangePasswordEditor.vue?vue&type=script&lang=js"
export * from "./ChangePasswordEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eab5608",
  null
  
)

export default component.exports